import { render, staticRenderFns } from "./cancelar-faturas.vue?vue&type=template&id=73cb5526&"
import script from "./cancelar-faturas.vue?vue&type=script&lang=ts&"
export * from "./cancelar-faturas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports